import rawProtocol from "../../shared/protocol.json";

interface ProtocolShape {
  sim: {
    timestep: number;
    steps_per_render_frame: number;
    rtf_pass_threshold: number;
  };
  ui: {
    cooldown_ms: number;
    unlock: {
      min_drags_per_side: number;
      min_active_ms_per_side: number;
    };
  };
  session: {
    arena_screens: number;
    total_units: number;
  };
}

export const protocol = rawProtocol as ProtocolShape;

export const TIMESTEP = protocol.sim.timestep;
export const STEPS_PER_FRAME = protocol.sim.steps_per_render_frame;
export const COOLDOWN_MS = protocol.ui.cooldown_ms;
export const MIN_DRAGS = protocol.ui.unlock.min_drags_per_side;
export const MIN_ACTIVE_MS = protocol.ui.unlock.min_active_ms_per_side;
export const STUCK_AVAILABLE_MS = 5_000;
